import {SaveCancelFooter} from '@/components-v2'
import {usePromotion} from '@/context/Promotion/PromotionContext'
import {useFeatureFlagLanguages} from '@/hooks/useFeatureFlagLanguages'
import {PromotionStep} from '@/types/promotion'
import {getIsNextDisabled} from '@/utils/promotions/promotions'
import {useLocation} from 'react-router-dom'

/**
 * Footer controls for the new themed Create Promotion flow.
 * Mirrors legacy behavior for draft, next/publish, and disabled states.
 * @param {{
 *  currentStep: import('@/types/promotion').PromotionStep,
 *  onCancel: () => void,
 *  onNext: () => void,
 *  isLoading?: boolean,
 * }} props
 */
export const PromotionFooter = ({currentStep, onCancel, onNext, isLoading = false}) => {
  const {promotion, handleDraft, promotionConfig} = usePromotion()
  const languages = useFeatureFlagLanguages()
  const location = useLocation()
  const {isDuplicating} = location.state || {}

  const isReview = currentStep === PromotionStep.REVIEW
  const isSaveDraftDisabled = promotion?.status?.toUpperCase() === 'PUBLISHED' && !isDuplicating

  return (
    <SaveCancelFooter
      handleCancel={onCancel}
      draftAction={handleDraft}
      nextAction={onNext}
      isReview={isReview}
      FormError={getIsNextDisabled(currentStep, promotion, languages, promotionConfig, false)}
      isLoading={isLoading}
      isSaveDraftDisabled={isSaveDraftDisabled}
    />
  )
}
